import React, {useState} from "react";
import {Box, Stack, Typography} from "@mui/material";
import {Star, Play} from "../../assets/files";
import styles from "./FilmDescription.module.css";
import CustomChip from "../Chip/Chip";
import {Button} from "../index";
import {IData} from "../Cards/types";
import {useLocation, useNavigate} from "react-router-dom";
import {routes} from "../../routes/routes";
import {AppDispatch} from "../../store";
import {useDispatch} from "react-redux";
import Keys from "../../constants/helper";
import {openVideoPlayer, stopPreview} from "../../store/player/playerSlice";
import {useTranslation} from "react-i18next";
import useResize from "../../hooks/useResize";
import clsx from "clsx";
import {formatToOneDecimal, handlePlayCustom} from "../../utils";
import {useLazyGetContentDetailsQuery} from "../../api/modules";
import {MOBILE_VERSION} from "../../constants";


interface IProps {
    data: IData | null | any;
    dataPreview?: IData[] | null;
    details?: boolean;
    isLive?: boolean;
    onSlideChange?: (index: number) => void;
    mobileBannerLayout?: boolean;
}

const FilmDescription: React.FC<IProps> = (props) => {
    const {t} = useTranslation("translations");
    const {innerWidth} = useResize()
    const {data, isLive = false, details = false, mobileBannerLayout = false} = props;
    const navigate = useNavigate();
    const location = useLocation();
    const genreArray = data?.genders && data?.genders.split(",") || [];
    const profileId = localStorage.getItem(Keys.EPIC_PROFILE_ID);
    const dispatch: AppDispatch = useDispatch();
    const [isLoader, setIsLoader] = useState<boolean>(false)
    const [getContentDetails] = useLazyGetContentDetailsQuery()
    const seasons = data?.season_count ?? 0
    const isSerial = seasons > 0 && data?.type === "SERIE";

    const handlePlay = async () => {
        handlePlayCustom({
            profileId: profileId,
            data: data.id,
            dispatch,
            setIsLoader,
            getContentDetails,
            openVideoPlayer,
            preferCacheValue: false,
        });
        dispatch(stopPreview());

    };


    return (
        <Box className={clsx(details && styles.box_details)}>
            <Box className={clsx(styles.box, mobileBannerLayout && styles.mobileBanner)}>
                <Box className={styles.bannerHeader}>
                    <Typography variant={"h2"}>{data?.title}</Typography>
                    <Stack direction="row" spacing={1} alignItems={"center"} gap={1}>
                        {data?.rating && <span className={styles.rating}><Star/> {formatToOneDecimal(data?.rating)}</span>}
                        {(data?.duration && !isSerial) && <CustomChip label={data?.duration} color="default"/>}
                        {isSerial && (
                            <CustomChip
                                label={`${seasons} ${t("Details.season").toLowerCase()}${seasons > 1 ? "s" : ""}`}
                                color="default"
                            />
                        )}
                        {data?.classification && <CustomChip label={data.classification} color="primary"/>}
                    </Stack>
                    <Typography variant={"h5"}>{data?.synopsis}</Typography>
                    <Stack direction="row" className={styles.chips}>
                        {genreArray.map((genre: string) => (
                            <CustomChip key={genre} label={genre} color="default"/>
                        ))}
                    </Stack>
                </Box>
                <Box className={styles.bannerFooter}>
                    {!details && (
                        <Stack
                            direction="row"
                            spacing={2}
                            mt={3}
                            zIndex={1}
                            className={clsx(styles.actions, mobileBannerLayout && styles.mobileBannerActions)}
                            justifyContent={innerWidth < MOBILE_VERSION ? "center" : "start"}>
                            <Button
                                sx={{height: 50}}
                                isLoading={isLoader}
                                color="primary"
                                variant="contained"
                                startIcon={<Play/>}
                                onClick={handlePlay}
                            >
                                {t("Buttons.play")}
                            </Button>
                            {!isLive &&
                            <Button
                                sx={{height: 50}}
                                color="secondary"
                                variant="contained"
                                onClick={() =>
                                    navigate(`${routes.details.details}/${data?.id}`, {
                                        state: {
                                            fromPath: `${location.pathname}${location.search}`,
                                        },
                                    })
                                }
                            >
                                {t("Buttons.details")}
                            </Button>}
                        </Stack>
                    )}
                </Box>
            </Box>
            {/*{!details &&     <VideoPlayerPreview data={dataPreview}/>}*/}
        </Box>
    );
};

export default FilmDescription;
